import { CommonColumnProps } from 'approot/activity-builder/activity-builder.constants';
import { ComponentInfoBox } from '../component.constants';
import * as Colours from 'approot/shared/styles/colours.style';
import { ZoomComponentModalProps } from 'approot/activity-builder/activity-builder-zoom-component-modal.constants';
import type { InteractiveLessonSectionFragment } from '../../lesson-builder.graphql.generated';
import { Settings } from 'approot/shared/richtext/richtext.constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import {
  COLOUR_BLUE,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_PURPLE,
  COLOUR_ORANGE,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_YELLOW,
  COLOUR_LIME,
  COLOUR_CYAN,
  COLOUR_AZURE,
} from 'approot/shared/colour/colour.constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<ComponentInfoBox, '__typename'> &
  ZoomComponentModalProps & { isStudent?: boolean };
export type EditProps = ViewProps & CommonColumnProps;
export type SettingsProps = EditProps;

export const INFO_BOX_DEFAULT_COLOUR = Colours.grey10;
export const INFO_BOX_TYPENAME = 'ActivitiesInfoBoxComponent';
export const INFO_BOX_COLOURS = [
  COLOUR_GREY,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_ORANGE,
  COLOUR_YELLOW,
  COLOUR_LIME,
  COLOUR_GREEN,
  COLOUR_CYAN,
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_PURPLE,
];

export type InfoBoxProperties = Pluck<
  Extract<
    Pluck<InteractiveLessonSectionFragment, 'components'>,
    { __typename: 'ActivitiesInfoBoxComponent' }
  >,
  'properties'
>;

export const RICHTEXT_SETTINGS: Settings = {
  placeholder: 'Type here...',
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export type InfoBoxStyles = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesInfoBoxComponent' }
  >,
  'properties.style'
>;
